export const useSubscribeAgoraChannel = (
  channelId: MaybeRefOrGetter<string>,
) => {
  const channelEventHook = createEventHook<RtmMessage>()
  const channelReadyEventHook = createEventHook<boolean>()
  let chatChannel: RtmChannel
  const { isConnected, client } = useAgora()

  function onChannelMessage(message: AgoraRtmMessage) {
    if (!message.text) return
    const rtmMsg = JSON.parse(message.text) as RtmMessage
    channelEventHook.trigger(rtmMsg)
  }

  whenever(
    isConnected,
    async (_, __, onCleanUp) => {
      onCleanUp(() => {
        chatChannel?.off('ChannelMessage', onChannelMessage)
      })
      const { channel } = await client.joinChannel(toValue(channelId))
      if (channel) {
        chatChannel = channel.instance
        chatChannel.on('ChannelMessage', onChannelMessage)
        channelReadyEventHook.trigger(true)
      }
    },
    {
      immediate: true,
    },
  )

  return {
    on: channelEventHook.on,
    off: channelEventHook.off,
    onReady: channelReadyEventHook.on,
  }
}
